/** @jsxImportSource @emotion/react */
import t from "../../theme";

const paragraphs = [
  "your one-stop shop for all things marketing! Our mission is to empower local entrepreneurs and businesses to reach new heights through effective marketing strategies and cutting-edge technology.",
  "Our platform provides a unique space for business owners to connect with their target audience, promote their products and services, and gain valuable insights from customer feedback. With our user-friendly interface and comprehensive database, you can easily reach and engage with your ideal customer.",
  "At MoneyMails, we believe in the power of data-driven marketing to drive real results. That's why we provide our users with the tools and resources they need to succeed in today's fast-paced marketplace. Whether you're looking to boost brand awareness, drive sales, or expand your customer base, we've got you covered.",
  "MoneyMails provides a platform for local entrepreneurs to showcase their deals, coupons, and business updates to the community. They can post their offers via email in two ways: Paid Mail and Informational Mail. With Paid Mail, they earn points (redeemable for cash) when users click on their emails. Informational Mail allows users to access coupons, deals, and vendor information with a single click.",
  "Our aim is to offer a one-stop platform for local deals on everyday essentials like grocery stores, haircuts, salons, and more. Additionally, we provide business owners with a robust database of users, enabling them to leverage our precise user list in every area, maximizing their reach and impact",
  "We offer local entrepreneurs a dedicated online space and exclusive access to a user list, enabling them to market and promote their business daily. Additionally, we provide valuable customer feedback on their products, empowering them to make informed decisions and drive growth",
  "Join our community today and discover the power of effective marketing for yourself!",
];

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    fontFamily: t.font.family,
  },
  heading: {
    margin: 0,
    fontSize: "1.75rem",
    fontWeight: 700,
    color: t.text.primary,
  },
  paragraph: {
    margin: 0,
    fontSize: "0.95rem",
    lineHeight: 1.7,
    color: t.text.secondary,
  },
};

const AboutContent = () => (
  <div css={styles.wrapper}>
    <h3 css={styles.heading}>Welcome to MoneyMails</h3>
    {paragraphs.map((paragraph) => (
      <p key={paragraph} css={styles.paragraph}>
        {paragraph}
      </p>
    ))}
  </div>
);

export default AboutContent;
